import { Routes } from "@angular/router";
import { AuthGuard } from "~guard/guard";
// [[Componentes da Aplicação]]
import { ProductViewComponent, CartSwapComponent, CartViewComponent, CheckoutViewComponent } from "./index";
// []
export const ModuleRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "cart",
        component: CartViewComponent,
      },
      {
        path: "cart/:uid/swap",
        component: CartSwapComponent,
      },
      {
        path: "checkout",
        component: CheckoutViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ":name/id/:id",
        component: ProductViewComponent,
      },
    ],
  },
];
